import { Component, OnInit, Input, OnChanges } from '@angular/core';

import { HelperService, HTTPService } from 'app/services';

@Component({
  selector: 'app-rd-wirings',
  templateUrl: './rd-wirings.component.html',
  styleUrls: ['./rd-wirings.component.scss'],
})
export class RdWiringsComponent implements OnInit, OnChanges {
  @Input() options: any = {};
  @Input() vehicleId: string = '';
  @Input() wirings: any[] = [];
  @Input() isProcessing: boolean = false;

  documentUrls: any[] = [];
  svgDocument: string = '';
  selectedWiringActive: any = {};

  imageIndex: number = 0;
  isLoading: boolean = false;
  isSVG: boolean = false;
  isWiringngSelected: boolean = false;
  selectedWiring = {
    displayName: '',
    details: [],
  };
  config = {
    btnClass: 'default',
    zoomFactor: 0.1,
    containerBackgroundColor: '#ccc',
    wheelZoom: true,
    allowFullscreen: true,
    allowKeyboardNavigation: true,
    btnIcons: {
      zoomIn: 'fal fa-search-plus',
      zoomOut: 'fal fa-search-minus',
      next: 'fas fa-caret-right',
      prev: 'fas fa-caret-left',
      fullscreen: 'fal fa-expand',
    },
    btnShow: {
      zoomIn: true,
      zoomOut: true,
      next: true,
      prev: true,
    },
  };

  constructor(
    private httpService: HTTPService,
    private helperService: HelperService
  ) {}

  ngOnInit() {
    this.fetchInitialDetails();
  }

  ngOnChanges(change: any) {
    const { isProcessing } = change;
    if (isProcessing) {
      if (isProcessing.previousValue && !isProcessing.currentValue) {
      }
    }
  }

  fetchInitialDetails() {
    if (this.isLoading) return;

    if (this.wirings.length) {
      this.selectedWiringActive = this.wirings[0];
      this.getWiringDetails(this.wirings[0]);
    }
  }

  getWiringDetails(wiring: any) {
    this.imageIndex = 0;
    this.isLoading = true;
    this.documentUrls = [];
    this.httpService
      .getWiringDiagramDetails({
        ...this.options,
        vehicleId: this.vehicleId,
        applicationId: wiring.applicationId,
      })
      .then(
        ({ images }) => {
          if (images && images.length) {
            this.isSVG = false;
            this.documentUrls = images.map(({ image }) => image);
          }
        },
        (err) => {
          this.helperService.showToaster('error', err);
        }
      )
      .finally(() => (this.isLoading = false));
  }

  handleBack() {}
}
